import React from "react";
import AboutBottom from "./AboutBottom";
import AboutTop from "./AboutTop";

function About() {
  return (
    <div>
      <AboutTop />
      <AboutBottom />
    </div>
  );
}

export default About;
